<header id="header" class="fixed-top">
  <div class="container-fluid d-flex">
    <div class="logo mr-auto my-auto">
      <a routerLink=""><img src="../../../../assets/images/logo.png" width="38" height="45" alt=""></a>
      <a routerLink="" class="pl-md-2 pl-2">Take a Breath</a>
    </div>
    <nav class="nav-menu d-none d-md-none d-lg-none d-xl-block">
      <ul>
        <li class="active"><a href="#header">How it Works</a></li>
        <li><a href="#">Portfolio</a></li>
        <li><a href="#">Seminars</a></li>
        <li><a href="#">Foundation</a></li>
        <li><a href="#">Take a Breath Week</a></li>
        <li><a href="#" id="nav-divider">Contact</a></li>
        <li class="sign-in"><a routerLink="/sign-in">Sign In</a></li>

        <li class="sign-up"><a routerLink="/sign-up">Sign Up</a></li>
      </ul>
    </nav>
  </div>
</header>
